var map = {
	"./_collections": 61,
	"./_collections.js": 61,
	"./_path": 182,
	"./_path.js": 182,
	"./_transforms": 219,
	"./_transforms.js": 219,
	"./addAttributesToSVGElement": 1810,
	"./addAttributesToSVGElement.js": 1810,
	"./addClassesToSVGElement": 1811,
	"./addClassesToSVGElement.js": 1811,
	"./cleanupAttrs": 1812,
	"./cleanupAttrs.js": 1812,
	"./cleanupEnableBackground": 1813,
	"./cleanupEnableBackground.js": 1813,
	"./cleanupIDs": 1814,
	"./cleanupIDs.js": 1814,
	"./cleanupListOfValues": 1815,
	"./cleanupListOfValues.js": 1815,
	"./cleanupNumericValues": 1816,
	"./cleanupNumericValues.js": 1816,
	"./collapseGroups": 1817,
	"./collapseGroups.js": 1817,
	"./convertColors": 1818,
	"./convertColors.js": 1818,
	"./convertPathData": 1819,
	"./convertPathData.js": 1819,
	"./convertShapeToPath": 1820,
	"./convertShapeToPath.js": 1820,
	"./convertStyleToAttrs": 1821,
	"./convertStyleToAttrs.js": 1821,
	"./convertTransform": 1822,
	"./convertTransform.js": 1822,
	"./mergePaths": 1823,
	"./mergePaths.js": 1823,
	"./minifyStyles": 1824,
	"./minifyStyles.js": 1824,
	"./moveElemsAttrsToGroup": 1825,
	"./moveElemsAttrsToGroup.js": 1825,
	"./moveGroupAttrsToElems": 1826,
	"./moveGroupAttrsToElems.js": 1826,
	"./removeAttrs": 1827,
	"./removeAttrs.js": 1827,
	"./removeComments": 1828,
	"./removeComments.js": 1828,
	"./removeDesc": 1829,
	"./removeDesc.js": 1829,
	"./removeDimensions": 1830,
	"./removeDimensions.js": 1830,
	"./removeDoctype": 1831,
	"./removeDoctype.js": 1831,
	"./removeEditorsNSData": 1832,
	"./removeEditorsNSData.js": 1832,
	"./removeElementsByAttr": 1833,
	"./removeElementsByAttr.js": 1833,
	"./removeEmptyAttrs": 1834,
	"./removeEmptyAttrs.js": 1834,
	"./removeEmptyContainers": 1835,
	"./removeEmptyContainers.js": 1835,
	"./removeEmptyText": 1836,
	"./removeEmptyText.js": 1836,
	"./removeHiddenElems": 1837,
	"./removeHiddenElems.js": 1837,
	"./removeMetadata": 1838,
	"./removeMetadata.js": 1838,
	"./removeNonInheritableGroupAttrs": 1839,
	"./removeNonInheritableGroupAttrs.js": 1839,
	"./removeRasterImages": 1840,
	"./removeRasterImages.js": 1840,
	"./removeStyleElement": 1841,
	"./removeStyleElement.js": 1841,
	"./removeTitle": 1842,
	"./removeTitle.js": 1842,
	"./removeUnknownsAndDefaults": 1843,
	"./removeUnknownsAndDefaults.js": 1843,
	"./removeUnusedNS": 1844,
	"./removeUnusedNS.js": 1844,
	"./removeUselessDefs": 1845,
	"./removeUselessDefs.js": 1845,
	"./removeUselessStrokeAndFill": 1846,
	"./removeUselessStrokeAndFill.js": 1846,
	"./removeViewBox": 1847,
	"./removeViewBox.js": 1847,
	"./removeXMLNS": 1848,
	"./removeXMLNS.js": 1848,
	"./removeXMLProcInst": 1849,
	"./removeXMLProcInst.js": 1849,
	"./sortAttrs": 1850,
	"./sortAttrs.js": 1850,
	"./transformsWithOnePath": 1851,
	"./transformsWithOnePath.js": 1851
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1809;



//////////////////
// WEBPACK FOOTER
// ./~/svgo/plugins ^\.\/.*$
// module id = 1809
// module chunks = 0